// : Add - 创建错误码常量定义文件 }}
// 参考 ct_oms_pc 项目的 ErrorCode，简化版本

/**
 * HTTP 错误码常量
 */
export const ErrorCode = {
  // 网络相关错误
  Http_ErrNetWork: 'HTTP_ERR_NETWORK',
  Http_ErrTimeout: 'HTTP_ERR_TIMEOUT',
  Http_ErrCanceled: 'HTTP_ERR_CANCELED',
  
  // HTTP 状态码相关
  Http_ErrNotFound: 'HTTP_ERR_NOT_FOUND',
  Http_ErrBadRequest: 'HTTP_ERR_BAD_REQUEST',
  Http_ErrServer: 'HTTP_ERR_SERVER',
  Http_ErrRequestTooMany: 'HTTP_ERR_REQUEST_TOO_MANY',
  
  // 认证相关
  Auth_Unauthorized: 'AUTH_UNAUTHORIZED',
  Auth_Forbidden: 'AUTH_FORBIDDEN',
  Http_RefreshError: 'HTTP_REFRESH_ERROR'
};

/**
 * 自定义 HTTP 错误类
 */
export class HttpError extends Error {
  constructor(code, message, originalError = null) {
    super(message);
    this.name = 'HttpError';
    this.code = code;
    this.originalError = originalError;
    
    // 保持正确的堆栈跟踪
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HttpError);
    }
  }
}

